import React from 'react';
import { Link } from 'react-router-dom';

export const DesktopNav = ({ navLinks, isActive, hoveredIndex, setHoveredIndex }) => {
  return (
    <div className="hidden lg:flex items-center">
      <div className="relative flex items-center gap-0">
        {navLinks.map((link, index) => {
          const showCloud = hoveredIndex === index || isActive(link.path);
          return (
            <Link
              key={link.path}
              to={link.path}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className={`relative px-5 py-2 text-lg font-semibold tracking-wide transition-all duration-300 z-10 ${
                isActive(link.path)
                  ? 'text-white'
                  : 'text-gray-400 hover:text-white'
              }`}
              data-testid={`nav-link-${link.name.toLowerCase()}`}
            >
              {/* Cloud hover background */}
              <span 
                className={`absolute inset-0 rounded-full transition-all duration-300 ease-out ${
                  showCloud ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
                }`}
                style={{
                  background: isActive(link.path) 
                    ? 'linear-gradient(135deg, rgba(249,115,22,0.2), rgba(34,197,94,0.15))'
                    : 'rgba(255,255,255,0.07)',
                  backdropFilter: 'blur(12px)',
                  boxShadow: isActive(link.path) 
                    ? '0 0 20px rgba(249,115,22,0.15), inset 0 1px 0 rgba(255,255,255,0.1)' 
                    : 'inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
              />
              {/* Text */}
              <span 
                className="relative transition-all duration-300"
                style={
                  hoveredIndex === index || isActive(link.path)
                    ? {
                        background: 'linear-gradient(to right, #f97316, #22c55e)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        filter: isActive(link.path) ? 'drop-shadow(0 0 8px rgba(249,115,22,0.6))' : 'none',
                      }
                    : {}
                }
              >
                {link.name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
